import DesignerHeader from "components/designerHeader";
import DesignerSidebar from "components/desingerSidebar";
import {
  Box,
  Button,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

// Types
interface Goal {
  id: string; // unique identifier
  student: string;
  studentGoal: string;
  smartGoal: string;
  importance: number;
  difficulty: number;
  goalWeight: number;
  baselineLevel: string;
  goalAchieved: string;
  achievementRating: string;
}

interface GroupedGoals {
  group: string | number;
  goals: Goal[];
}

// Sample data
const groupedData: GroupedGoals[] = [
  {
    group: "1",
    goals: [
      {
        id: "g1",
        student: "Albert Flores",
        studentGoal: "To be more competent carer.",
        smartGoal: "To deal with my own emotional reactions.",
        importance: 3,
        difficulty: 2,
        goalWeight: 6,
        baselineLevel: "It’s Ongoing",
        goalAchieved: "Yes (including partial achievement)",
        achievementRating: "As expected",
      },
      {
        id: "g2",
        student: "Albert Flores",
        studentGoal: "To be a better career advocate",
        smartGoal:
          "To understand how to navigate the mental health system better.",
        importance: 3,
        difficulty: 2,
        goalWeight: 6,
        baselineLevel: "It’s Ongoing",
        goalAchieved: "Yes (including partial achievement)",
        achievementRating: "A little",
      },
    ],
  },
  {
    group: "2",
    goals: [
      {
        id: "g3",
        student: "Albert Flores",
        studentGoal: "To use our lived",
        smartGoal: "To deal with my own emotional reactions.",
        importance: 3,
        difficulty: 2,
        goalWeight: 6,
        baselineLevel: "It's Ongoing",
        goalAchieved: "Yes (including partial achievement)",
        achievementRating: "As expected",
      },
    ],
  },
];

const designerViewSLPGoals: React.FC = () => {
  return (
    <div className="wrapper">
      <Box
        className="overlay"
        onClick={() => document.body.classList.toggle("sidebar-toggle")}
      />
      <DesignerHeader />
      <main>
        <DesignerSidebar />
        <div className="main-content">
          <Box className="content-header simple-header">
            <Typography variant="h2" className="heading">
              View SLP Goals & Assessment
            </Typography>
            <Box sx={{ display: "flex", columnGap: "14px" }}>
              <Button variant="outlined" className="px-16">
                Print
              </Button>
              <Button
                variant="outlined"
                className="px-16"
                component={Link}
                to="/designer-student-profile-details"
              >
                Back
              </Button>
            </Box>
          </Box>
          <Grid
            container
            spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
            className="content-container"
          >
            <Grid item xs={12}>
              <Card className="info-card">
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Student Details
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
                >
                  {/* Line 1 */}
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Full Name
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Jacquelin Bellido
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      SLP number
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      4
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      SLP ID
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      4473
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Date Completed
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      20/11/1998
                    </Typography>
                  </Grid>
                  {/* Line 2 */}
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      PLA Name
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Alex Li
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Active Community eMR (at enrolment)
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Unknown
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card className="info-card">
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Hopes, Goals and Ambitions
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
                >
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Current Circumstances: What changes have occurred since
                      your last learning plan?
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Recovery College: How has your perspective on recovery
                      changes since your involvement with the Recovery College?
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Future Plans : What are your future plans?
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Strengths: What are the strengths and attributes that you
                      now know about yourself?
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. incididunt ut labore et magna aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      NDIS
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Employment Assistance
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      WDO
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut aliqua.
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card className="info-card">
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Where to from Here
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
                >
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Supports: Is there any special help or support you will
                      need to take part in the Recovery and Wellbeing College?
                      How would you like this to be provided?
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Is there anyone else you would like to share this Learning
                      Plan with?
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Positive Outcomes
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    SLP Goals
                  </Typography>
                  <Box>
                    <Button variant="contained">Add New Goals</Button>
                  </Box>
                </Box>
                <TableContainer>
                  <Table className="table-h-md">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            maxWidth: "120px",
                            width: "120px",
                            minWidth: "120px",
                          }}
                        >
                          Student
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "200px",
                            width: "200px",
                            minWidth: "200px",
                          }}
                        >
                          Student Goal
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "250px",
                            width: "250px",
                            minWidth: "250px",
                          }}
                        >
                          Smart Goal
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "100px",
                            width: "100px",
                            minWidth: "100px",
                          }}
                        >
                          Importance
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "100px",
                            width: "100px",
                            minWidth: "100px",
                          }}
                        >
                          Difficulty
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "100px",
                            width: "100px",
                            minWidth: "100px",
                          }}
                        >
                          Goal Weight
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "100px",
                            width: "100px",
                            minWidth: "100px",
                          }}
                        >
                          Baseline Level
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "170px",
                            width: "170px",
                            minWidth: "170px",
                          }}
                        >
                          Goal Achieved?
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: "120px",
                            width: "120px",
                            minWidth: "120px",
                          }}
                        >
                          Achievement Rating
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupedData.map((group) => (
                        <React.Fragment key={`group-${group.group}`}>
                          <TableRow>
                            <TableCell colSpan={9}>
                              <Typography>{group.group}</Typography>
                            </TableCell>
                          </TableRow>
                          {group.goals.map((goal) => (
                            <TableRow key={goal.id}>
                              <TableCell>{goal.student}</TableCell>
                              <TableCell>{goal.studentGoal}</TableCell>
                              <TableCell>{goal.smartGoal}</TableCell>
                              <TableCell>{goal.importance}</TableCell>
                              <TableCell>{goal.difficulty}</TableCell>
                              <TableCell>{goal.goalWeight}</TableCell>
                              <TableCell>{goal.baselineLevel}</TableCell>
                              <TableCell>{goal.goalAchieved}</TableCell>
                              <TableCell>{goal.achievementRating}</TableCell>
                            </TableRow>
                          ))}
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
          </Grid>
        </div>
      </main>
    </div>
  );
};

export default designerViewSLPGoals;
